//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useContext } from "react";
import { Outlet } from "react-router-dom";

import { CandidatePageActions } from "../candidatePageActions";
import { Context } from "../common/context/Context";
// import Settings from "../components/Settings";
import MainLayout from "../aAdminTabTeam2/layout/MainLayout";



const Dashboard = () => {
    // const children = [{}]
    const context = useContext(Context);
    const [permissionPages, setPermissionPages] = useState([])
    const [errorAlert, setErrorAlert] = useState({
        showAlert: false
    })
    const showErrorModal = () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        refErrorMessageAlert.showAlert = false;
        setErrorAlert(refErrorMessageAlert)
    }

    const getRolePermissions = () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        CandidatePageActions.GetRolePermissions().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    handleRolePermissionsSuccess(res.data);
                } else if (res.status === 403) {
                    context.setIsUserActive(false);
                    context.setAdminUser(false);
                } else {
                    showError(refErrorMessageAlert);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    };

    function handleRolePermissionsSuccess(resData) {
        if (!resData) return;
        let pagesList = resData.permissionPages || [];
        // Manually push RTI_setUp to permission array
        pagesList.push(['Client Portal Setup']);

        context.setAdminUser(pagesList.length > 0);
        context.setIsUserActive(!!resData.isUserActive);

        let dashBoardIndex = pagesList.indexOf("Dashboard");
        if (dashBoardIndex > -1) {
            [pagesList[dashBoardIndex], pagesList[0]] = [pagesList[0], pagesList[dashBoardIndex]];
        }
        setPermissionPages(pagesList);

        let permissionComponents = Array.isArray(resData.permissions)
            ? resData.permissions.map(item => item.trim())
            : [];
        context.setPermissionsList(permissionComponents);
    }

    function showError(refErrorMessageAlert) {
        refErrorMessageAlert.showAlert = true;
        setErrorAlert(refErrorMessageAlert);
        window.scrollTo(0, 0);
    }

    // function for fetching the navigation cmd content
    const getAdminNavigationCMSContent = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        const payload = { pagename: 'Navigation' }
        await CandidatePageActions.getAdminCandidateCMSContent(payload).then((res) => {
            if (res.status == 200 || res.status == 204) {
                const data = res.data;
                data.Pages.forEach((el) => {
                    if (el.Key === 'Navigation') {
                        context.setAdminNavigationCmsData(el);
                    }
                });
            }
            else {
                refErrorMessageAlert.showAlert = true;
                setErrorAlert(refErrorMessageAlert);
                window.scrollTo(0, 0);
            }
        });

    }

    useEffect(() => {
        window.scrollTo(0, 0)
        if (window.sessionStorage.getItem('AccessToken') !== null) {
            getRolePermissions()
        }
        getAdminNavigationCMSContent();
    }, [])

    return (
        <MainLayout>
            <Outlet />
        </MainLayout>
    )
}

export default Dashboard;
